<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import EventDetail from 'components/EventDetail'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'
import eventService from 'api/event'

export default {
  name: 'venue-app-event',
  components: {
    EventDetail,
  },
  data() {
    return {
      eventId: this.$route.params.eventId,
      event: null,
      prevRoute: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
  },
  methods: {
    goBack() {
      this.$router.push({
        name: !this.prevRoute || !this.prevRoute.name || this.prevRoute.name === 'VenueApp' ? 'VenueAppHome' : this.prevRoute.name,
        query: this.$route.query,
        params: this.prevRoute ? this.prevRoute.params : null,
      })
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        this.$router.push({
          name: 'VenueAppCheckout',
          params: {
            venueId: this.venue.slug,
            eventId: this.eventId,
          },
        })
      }

      return null
    },
    getEvent() {
      return eventService
        .getById(this.eventId, {
          fields: ['venue()'].join(','),
        })
        .then((event) => {
          this.event = event
        })
        .catch(() => {
          this.eventNotFound = true
        })
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.getEvent()
      .then(() => {
        return null
      })
      .catch(() => {
        return null
      })
  },
  destroyed() {
    this.storeUnsubscribe()
  },
  metaInfo() {
    let pageTitle = `${this.venue.name} | Powered by TablelistPro`
    const pageDescription = ''
    let ogImage

    if (this.event) {
      pageTitle = `Buy tickets and tables to ${this.event.name}`
      ogImage = this.event.primaryImage ? this.event.primaryImage.filename : ''

      if (this.venue.id === '6de0573d185fa3ed') {
        pageTitle = `Buy tables to ${this.event.name}`
      }
    }

    const meta = [
      {
        property: 'og:title',
        content: pageTitle,
      },
      {
        property: 'og:description',
        content: pageDescription,
      },
      {
        property: 'og:type',
        content: 'product',
      },
      {
        property: 'og:url',
        content: window.location.href,
      },
    ]

    if (ogImage) {
      meta.push({
        property: 'og:image',
        content: ogImage,
      })
    }

    return {
      title: pageTitle,
      meta,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Venue/VenueAppEvent/index.vue